import React, { memo, useCallback } from 'react';
import FormRangeControl from './FormRangeControl';
import { formActions, useAppDispatch, useAppSelector } from '../../data/store';

const Scale = () => {

    const dispatch = useAppDispatch();
    const scale = useAppSelector(store => store.form.scale);

    const updateScale = useCallback((updatedValue: number) => {
        dispatch(
            formActions.main({
                scale: updatedValue,
            })
        );
    }, [dispatch]);

    return (
        <FormRangeControl
            title={ 'Scale' }
            value={ scale }
            min={ 0 }
            max={ 2 }
            onChange={ updateScale }
        />
    )
};

export default memo(Scale);